import React from 'react';
import { Stack } from '@mui/material';
import { Sample } from '../../../data/SampleData';
import { GenericTextBadge } from '../../GenericTextBadge';

export interface SampleTagGridCellProps {
  sample: Sample;
}

export const SampleTagGridCell = ({ sample }: SampleTagGridCellProps) => {
  return sample?.sampleId && sample.sampleTags ? (
    <Stack direction='row' alignItems='left' spacing={1}>
      {sample.sampleTags.map((label: string) => {
        return (
          <GenericTextBadge
            key={label}
            displayText={label}
            textColor={'#0c5460'}
            fillColor={'#d1ecf1'}
            strokeColor={'#9dd2dc'}
          />
        );
      })}
    </Stack>
  ) : null;
};
